import Reservation from "@components/Reservation";
import useConfig from "@lib/use_config";
import useContent from "@lib/use_content";
import { formatCurrency } from "@utils/i18n";
import useWindowSize from "@utils/use_window_size";
import Contact from "./Contact";
import Payment from "./Payment";

function Booking({ booking }: { booking?: be.Booking }): JSX.Element | null {
  const { data: configData } = useConfig(["currency"]);
  const { data, loading, error } = useContent([
    "beRessummaryAmountPaidLabel",
    "beRessummaryTotalLabel",
    "beRessummaryPointsUsedLabel",
  ]);
  const [size] = useWindowSize();

  return !booking ? null : (
    <div className="max-w-md mx-auto sm:max-w-5xl">
      {booking.activeLegs().map((leg: be.Reservation, i: number) => (
        <div
          className="border-b-4 relative bg-gray-50 my-6 px-6 xs:px-12 sm:px-6 py-6 rounded-2xl shadow-sm border-x-[6px] border-x-[--primary-color]"
          key={i}
        >
          <Reservation
            hideSubFares={true}
            key={i}
            res={leg}
            serviceArea={booking.serviceArea}
            vertical={size < 640}
          />
        </div>
      ))}

      <div className="flex flex-col items-end justify-end ml-0 mr-8 gap-y-8 sm:items-start sm:flex-row gap-x-16 justify-items-center normal:mr-16 ">
        <Contact contact={booking.contactInfo} />
        <Payment payment={booking.payment} />

        <div className="flex flex-col gap-y-3">
          {!booking?.legs[0].cancelled && booking?.legs[0].service?.hideFareMode == "never" && (
            <dl className="mt-3">
              <div className="flex items-center justify-between border-gray-200 gap-x-6 ">
                <dt className="mr-4 text-xl font-medium">{data?.content.beRessummaryTotalLabel}</dt>
                <dd className="text-xl font-bold text-gray-900 font-number">
                  {formatCurrency(booking.total())}
                </dd>
              </div>
            </dl>
          )}

          {booking.totalPointsDeductionsInMoney() != 0 && (
            <>
              <div className="flex items-center justify-between border-gray-200 gap-x-6 ">
                <dt className="font-light text-gray-500 text-md">
                  {data?.content.beRessummaryPointsUsedLabel}
                </dt>
                <dd className="text-gray-500 text-md font-number">
                  {formatCurrency(
                    booking.totalPointsDeductionsInMoney(),
                    configData?.config.currency,
                  )}
                </dd>
              </div>

              <div className="flex items-center justify-between border-gray-200 gap-x-6 ">
                <dt className="text-xl font-medium">{data?.content.beRessummaryAmountPaidLabel}</dt>
                <dd className="text-xl font-extrabold text-gray-900 font-number">
                  {formatCurrency(booking.totalDue(), configData?.config.currency)}
                </dd>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Booking;
